import React from "react";
import { Box, Grid, Stack, Skeleton } from "@mui/material";
import { Card, SectionTitle, MetricCard, SendIcon, RadarIcon, ShieldCheckIcon, T } from "./dashboardUtils";

const CARDS = [
  { key: "requestsSent", title: "Requests Sent", sub: "All brokers contacted", icon: <SendIcon size={18} /> },
  { key: "requestsInProgress", title: "In Progress", sub: "Removals in progress", icon: <RadarIcon size={18} /> },
  { key: "dataDeleted", title: "Data Deleted", sub: "Confirmed removals", icon: <ShieldCheckIcon size={18} /> },
];

function MetricSkeleton() {
  return (
    <Box sx={{ bgcolor: T.surface, border: `1px solid ${T.border}`, borderRadius: 2, p: 2, height: "100%", boxSizing: "border-box" }}>
      <Stack direction="row" justifyContent="space-between" mb={1.5}>
        <Skeleton variant="rounded" width={34} height={34} />
        <Skeleton variant="text" width={80} height={14} />
      </Stack>
      <Skeleton variant="text" width={50} height={44} />
      <Skeleton variant="text" width="65%" height={14} sx={{ mt: 0.75 }} />
    </Box>
  );
}

export default function RequestStatusOverview({ isLoading, requestsSent, requestsInProgress, dataDeleted }) {
  const values = { requestsSent, requestsInProgress, dataDeleted };

  return (
    <Card sx={{ mb: 2.5, mt: 2.5 }}>
      <SectionTitle title="Request Status Overview" subtitle="Tracking all deletion requests" />
      <Box sx={{ p: 2.5 }}>
        <Grid container spacing={2} alignItems="stretch">
          {CARDS.map((card) => (
            <Grid key={card.key} size={{ xs: 12, sm: 4 }}>
              {isLoading ? <MetricSkeleton /> : (
                <MetricCard
                  title={card.title}
                  value={values[card.key]}
                  sub={card.sub}
                  icon={card.icon}
                />
              )}
            </Grid>
          ))}
        </Grid>
      </Box>
    </Card>
  );
}
